<div
    appBsModal
    #modal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modal"
    (onShown)="shown()"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ options.title }}
                </h4>

                <div>
                    <button type="button" class="btn btn-default" (click)="close()">{{"Cancel" | localize}}</button>
                </div>
                <!-- <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')">
                    <span aria-hidden="true">&times;</span>
                </button> -->
            </div>
            <div class="modal-body">
                <form novalidate autocomplete="new-password">
                    <div *ngIf="options.isFilterEnabled" class="input-group mb-4">
                        <input
                            autoFocus (ngModelChange)="searchSubject.next($event)"
                            [ngModel]="filterText"
                            name="filterText"
                            class="form-control"
                            placeholder="{{ 'SearchWithThreeDot' | localize }}"
                            type="text"
                        />
                        <!-- <div class="input-group-append">
                            <button class="btn btn btn-primary" type="submit">
                                <i class="flaticon-search-1" [attr.aria-label]="l('Search')"></i>
                            </button>
                        </div> -->
                    </div>

                    <!--<Primeng-TurboTable-Start>-->
                    <div class="primeng-datatable-container" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getRecordsIfNeeds($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            [lazy]="true"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 55px">
                                        {{'Select' | localize}}
                                    </th>
                                    <th>
                                        {{ 'Name' | localize }}
                                    </th>
                                    <th style="width: 125px" *ngIf="!options.displayOnlyName">
                                        {{'Role' | localize}}
                                    </th>
                                    <th *ngIf="!options.displayOnlyName && !options.dontDisplayCompany">
                                        {{'CompanyName' | localize}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit">
                                <tr>
                                    <td style="width: 55px">
                                        <div class="table-action-container">
                                            <a href="javascript:void(0)" class="btn" (click)="selectItem(record)"
                                                title="{{'Select' | localize}}">
                                                <i class="la la-chevron-circle-right"
                                                    [attr.aria-label]="l('Select')"></i>
                                            </a>
                                        </div>
                                    </td>
                                    <td>
                                        <span class="p-column-title">{{ 'Name' | localize }}</span>
                                        {{ record.name }}
                                    </td>
                                    <td style="width: 125px" *ngIf="!options.displayOnlyName">
                                        <span class="p-column-title">{{"Role" | localize}}</span>
                                        {{record.role}}
                                    </td>
                                    <td *ngIf="!options.displayOnlyName && !options.dontDisplayCompany">
                                        <span class="p-column-title">{{"CompanyName" | localize}}</span>
                                        {{record.companyName}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ 'NoData' | localize }}
                        </div>
                        <div class="primeng-paging-container"
                            [hidden]="primengTableHelper.defaultRecordsCountPerPage >= primengTableHelper.totalRecordsCount">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getRecordsIfNeeds($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-TurboTable-End>-->
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default fw-bold" (click)="close()">
                    {{ 'Cancel' | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
